import http from "../core/http";
const group = 'transactionReports';

export const getInitialDataRequest = async (data) => {
    return await http.post(`${group}/getInitialData`, data).then(res => res.data).catch(http.defaultCatch);
}

export const getTransactionReportRequest = async (data) => {
    return await http.post(`${group}/getReport`, data).then(res => res.data).catch(http.defaultCatch);
}

export const exportTransactionReportRequest = async (data) => {
    return await http.post(`${group}/export`, data, { responseType: 'blob' }).then(res => res.data).catch(http.defaultCatch);
} 